module.exports = __webpack_public_path__ + "img/Iconset_DGBRT--03.95d6ce5e.png";